<!--全局变量公共类-->
<script>
/* 所有请求的http*/
/* 外网*/
const http = '/nemojoyWebsiteJson/'
const fileHttp = ''

// 本地用外网资源
// const http = 'https://www.nemojoy.com/nemojoyWebsiteJson/'
// const fileHttp = 'https://www.nemojoy.com/'

/* 测试*/
// const http = 'http://localhost:810/'
// const http = 'http://192.168.0.177:810/'
// const fileHttp = 'http://192.168.0.198:801'

export default {
  http,
  fileHttp
}
</script>
